var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.advertisement.id),expression:"advertisement.id"}],staticClass:"advertisement-large"},[_c('div',{staticClass:"pxindBox"},[_c('img',{attrs:{"src":_vm.advertisement.images,"alt":""},on:{"click":_vm.jumpCourseDetail}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }